import { Sizes } from "@/components"
import { PdpPrice } from "@/components/Pdp/PdpPrice"
import { useStores } from "@/stores"
import { Link, NextImage, PdpLoader, getProductUrl, useAddedProduct, useI18n, usePending } from "@jog/react-components"
import { getGtmIdFromCT, getPdp, gtmAddPdpProductToCart, gtmAdpageAddToCart } from "@jog/shared"
import { PdpProduct, TweakwiseItem } from "@jog/types"
import { observer } from "mobx-react"
import { useCallback, useEffect, useState } from "react"

export const Product = observer(({ product }: { product: TweakwiseItem }) => {
    const { cartStore } = useStores()
    const [sku, setSku] = useState("")
    const [pending, setPending] = useState(true)
    const [productData, setProductData] = useState<PdpProduct | null>(null)
    const fetchPdpData = useCallback(async () => {
        setPending(true)
        await getPdp(product.itemno)
            .then((res) => {
                setProductData(res)
            })
            .finally(() => {
                setPending(false)
            })
    }, [product.itemno])
    useEffect(() => {
        fetchPdpData().catch(() => {})
    }, [fetchPdpData])

    const { $t } = useI18n()
    const { addedProduct } = useAddedProduct()
    const { setPending: setGlobalPending } = usePending()
    const addProductToCart = async () => {
        if (!sku) {
            const $size = document.querySelector(`#size-${productData.id}`)
            if ($size) {
                $size.scrollIntoView({ behavior: "smooth", block: "center" })
            }
            return
        }
        setGlobalPending(true)
        await cartStore.addProductsToCart([{ sku, quantity: 1 }]).finally(() => setGlobalPending(false))
        addedProduct(sku)
        gtmAddPdpProductToCart(productData, window.location.href)
        gtmAdpageAddToCart(productData, sku, getGtmIdFromCT(productData.attributes), window.location.href)
    }

    const linkItem = getProductUrl(product)

    return (
        <div className="border-b border-b-black py-8 first:pt-0 last:border-b-0">
            <div className="grid grid-cols-12 grid-rows-[auto_1fr]">
                <div className="col-span-12 lg:col-span-6 lg:col-start-7">
                    <Link
                        href={linkItem}
                        target="_blank"
                        className="pb-0 text-[22px] uppercase text-gray-base lg:pb-2.5 lg:text-[21px]">
                        {product.title}
                    </Link>
                </div>
                <div className="col-span-12 flex items-start lg:col-span-6 lg:row-span-2 lg:row-start-1">
                    <Link href={linkItem} target="_blank" rel="noopener" aria-label={product.title}>
                        <NextImage className="img-fluid" src={product.image} alt="" height={240} width={160} />
                    </Link>
                </div>
                {pending ? (
                    <PdpLoader />
                ) : productData ? (
                    <div
                        id={`size-${productData.id}`}
                        className="col-span-12 lg:col-span-6 lg:col-start-7 lg:row-start-2">
                        <PdpPrice productData={productData} showLabel={false} />
                        <Sizes sizes={productData.sizeGroup} setSku={setSku} sku={sku} />
                        <div className="mt-6 w-full">
                            <button
                                onClick={addProductToCart}
                                className="group flex h-12 w-full items-center justify-center bg-black text-gray-cream focus:outline-none">
                                <span className="text-sm uppercase">{$t("Add To Cart")}</span>
                            </button>
                        </div>
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </div>
    )
})
